import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { jsx as _jsx } from "react/jsx-runtime";
export const SessionIdContext = /*#__PURE__*/React.createContext(undefined);
SessionIdContext.displayName = 'SessionIdContext';
export function defaultSessionIdGenerator() {
  return uuidv4();
}
export const SessionIdProvider = _ref => {
  let {
    generator = defaultSessionIdGenerator,
    storage,
    children
  } = _ref;
  const provider = useMemo(() => {
    const generateSessionId = () => {
      const sessionId = generator();
      storage.setSessionId(sessionId);
      return sessionId;
    };
    const getOrGenerateSessionId = () => {
      const storedSessionId = storage.getSessionId({
        extendSession: true
      });
      if (storedSessionId) {
        return storedSessionId;
      }
      return generateSessionId();
    };
    getOrGenerateSessionId();
    return {
      generateSessionId,
      getOrGenerateSessionId
    };
  }, [generator, storage]);
  return /*#__PURE__*/_jsx(SessionIdContext.Provider, {
    value: provider,
    children: children
  });
};